
import Vue from 'vue'
import { format, formatDistance, formatRelative, subDays } from "date-fns";
import es from "date-fns/locale/es";

export const formatearFecha = (fecha) => {
    if (fecha == null || fecha == "") {
        return "-";
    }
    return format(new Date(fecha), "dd/LLL/yyyy", {locale: es});
};

export const formatearRut = (rut) => {
    if(rut == null){
        return "-"
    }
    var rutaFormatear = rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
    let len = rutaFormatear.length - 1;
    if (len > 3) {
        let dv = rutaFormatear[len];
        let beforeDv = rutaFormatear.substring(0, len).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        rutaFormatear = beforeDv + '-' + dv;
    }
    return rutaFormatear;
};

export const validarNegativos =  (valor, usarSigno=false) => {
    let tipoFiltro = usarSigno?'currency':'soloNumeros'
    
    if(parseInt(valor) > 0){
        return Vue.filter(tipoFiltro)(valor)
    }
    else if(parseInt(valor) == 0){
        return '0'
    } else{
        return `(${(Vue.filter(tipoFiltro)(valor * -1))})`
    }
};

